import { defineStore } from 'pinia'
import { ref } from 'vue'
import rolesAPI from '@/api/roles'

type Permission = { name: string; label: string; category: string };

export const useRolesStore = defineStore('roles', () => {
  const roles = ref<any[]>([])
  const permissions = ref<Permission[]>([]);
  const loading = ref(false);

  const fetchRoles = async (filters: any = {}) => {
    try {
      const response = await rolesAPI.getRoles(filters)
      roles.value = response.data?.data || response.data || []
    } catch (error) {
      console.error('Error fetching roles:', error)
    }
  }

  const fetchPermissions = async () => {
    try {
      loading.value = true;
      const { data } = await rolesAPI.getPermissions();
      permissions.value = data?.data || data || [];
    } finally {
      loading.value = false;
    }
  };

  const createRole = async (roleData: any) => {
    try {
      const response = await rolesAPI.createRole(roleData)
      await fetchRoles()
      return response.data
    } catch (error) {
      console.error('Error creating role:', error)
      throw error
    }
  }

  const updateRole = async (id: number, roleData: any) => {
    try {
      const response = await rolesAPI.updateRole(id, roleData)
      await fetchRoles()
      return response.data
    } catch (error) {
      console.error('Error updating role:', error)
      throw error
    }
  }

  const deleteRole = async (id: number) => {
    try {
      const response = await rolesAPI.deleteRole(id)
      await fetchRoles()
      return response.data
    } catch (error) {
      console.error('Error deleting role:', error)
      throw error
    }
  }

  const syncRolePermissions = async (roleId: number, selected: string[]) => {
    const res = await rolesAPI.syncRolePermissions(roleId, selected);
    return res.data;
  };

  return {
    roles,
    permissions,
    loading,
    fetchRoles,
    fetchPermissions,
    createRole,
    updateRole,
    deleteRole,
    syncRolePermissions,
  }
})
